import Swiper, { Scrollbar } from 'swiper';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default $wire => ({
    mySwiper: null,

    init() {
        let slider = document.getElementById('gallery_slider');
        if (slider != null) {
            this.mySwiper = new Swiper(slider, this.getSliderOptions());
        }
    },

    getSliderOptions() {
        return {
            modules: [Scrollbar],
            initialSlide: 0,
            observer: true,
            lazy: true,
            spaceBetween: 4,
            slidesPerView: 4.25,
            watchSlidesProgress: true,
            mousewheel: true,
            freeMode: true,
            clickable: true,
            scrollbar: {
                el: document.getElementById('swiper-scrollbar-thumbs'),
                draggable: true,
            },
            slideToClickedSlide: true,
            breakpoints: {
                /* Above */
                768: {
                    slidesPerView: 6.25,
                },
                992: {
                    slidesPerView: 4.25,
                },
                1200: {
                    slidesPerView: 6.25,
                },
            },
        };
    },
});
